import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import industryIntegration from "../../images/v4/TgPages/it/itIndustry.png";
import DesignCrmCarousel from "../../components/v4/designCarousel/DesignCarousel";
import salesmanpageHerobg from "../../images/v4/salesManagers/salesMangerHero.png";
import salesCrmCarouselbg from "../../images/v4/salesManagers/salesCrmbg.png";
import realWorldbg from "../../images/v4/salesManagers/realWorldbg.png";

import salesImg1 from "../../images/v4/TgPages/it/sales/img1.svg";
import salesImg2 from "../../images/v4/TgPages/it/sales/img2.svg";
import salesImg3 from "../../images/v4/TgPages/it/sales/img3.svg";
import salesImg4 from "../../images/v4/TgPages/it/sales/img4.svg";
import salesImg5 from "../../images/v4/TgPages/it/sales/img5.svg";
import salesImg6 from "../../images/v4/TgPages/it/sales/img6.svg";

import adaptImg1 from "../../images/v4/salesManagers/clientSlider/img1.png";
import adaptImg2 from "../../images/v4/salesManagers/clientSlider/img2.png";
import adaptImg3 from "../../images/v4/salesManagers/clientSlider/img3.png";
import adaptImg4 from "../../images/v4/salesManagers/clientSlider/img4.png";
import adaptImg5 from "../../images/v4/salesManagers/clientSlider/img5.png";
import adaptImg6 from "../../images/v4/salesManagers/clientSlider/img6.png";
import adaptImg7 from "../../images/v4/salesManagers/clientSlider/img7.png";

import bannerIcon1 from "../../images/v4/TgPages/it/bannerIcons/icon1.svg";
import bannerIcon2 from "../../images/v4/TgPages/it/bannerIcons/icon2.svg";
import bannerIcon3 from "../../images/v4/TgPages/it/bannerIcons/icon3.svg";
import bannerIcon4 from "../../images/v4/TgPages/it/bannerIcons/icon4.svg";

import bussinessSuccessbg from "../../images/v4/salesManagers/bussinessSuccess.png";

import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import bannerTick from "../../images/v4/salesReps/heroTick.svg";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/salesReps/topcrm/zoho.png";
import compareItemImg3 from "../../images/v4/salesReps/topcrm/engage.png";
import compareItemImg4 from "../../images/v4/salesReps/topcrm/freshsale.png";
import compareItemImg5 from "../../images/v4/salesReps/topcrm/monday.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";

import realWorldImage2 from "../../images/v4/TgPages/it/realWorld/real1.png";
import realWorldImage3 from "../../images/v4/TgPages/it/realWorld/real2.png";
import realWorldImage4 from "../../images/v4/TgPages/it/realWorld/real4.png";
import realWorldImage5 from "../../images/v4/TgPages/it/realWorld/real3.png";
import realWorldImage6 from "../../images/v4/TgPages/it/realWorld/real5.png";

import broadcastImg1 from "../../images/v4/salesReps/Designfor/broadcast1.png";
import broadcastImg2 from "../../images/v4/salesReps/Designfor/broadcast2.png";
import broadcastImg3 from "../../images/v4/salesReps/Designfor/broadcast3.png";
import broadcastImg4 from "../../images/v4/salesReps/Designfor/broadcast4.png";
import broadcastImg5 from "../../images/v4/salesReps/Designfor/broadcast5.png";

import experienceImg2 from "../../images/v4/TgPages/it/experience/exp1.png";
import experienceImg3 from "../../images/v4/TgPages/it/experience/exp2.png";
import experienceImg4 from "../../images/v4/TgPages/it/experience/exp3.png";
import experienceImg5 from "../../images/v4/TgPages/it/experience/exp4.png";
import experienceImg6 from "../../images/v4/TgPages/it/experience/exp5.png";

import arrowRight from "../../images/v4/salesReps/arrowRight.svg";

const useStyles = makeStyles((theme) => ({
  SalesMangerSection: {
    backgroundSize: "cover",
    backgroundImage: `url(${salesmanpageHerobg})`,
    padding: "60px 0 0",
    backgroundPosition: "top",
    overflow: "hidden",
    "@media only screen and (max-width: 1024px)": {
      maxHeight: "100%",
      minHeight: "100%",
      "& .container": {
        height: "auto",
      },
      "& .centerContainer": {
        width: "90%",
        marginTop: "50px",
      },
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },

    "@media only screen and (max-width: 768px)": {
      padding: "0",
      "& .centerContainer": {
        width: "95%",
        marginTop: "40px",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        marginTop: "20px",
        gap: "16px",
      },
    },
  },
  SalesMangerContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  },
  heroContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "32px",
    textAlign: "center",
    margin: "0 auto 64px",
    maxWidth: "1200px",
    "& p": {
      maxWidth: "1000px",
      marginBottom: "8px",
    },
    "@media(max-width:1024px)": {
      "& h1": {
        margin: "0",
      },
    },
  },
  bannerCards: {
    display: "flex",
    alignItems: "flex-start",
    gap: "24px",
    flexWrap: "nowrap", // default unless overridden below
    "& .bannerCard:nth-of-type(1), & .bannerCard:nth-of-type(4)": {
      transform: "translateY(25px) !important",
    },
    "@media (max-width:1024px)": {
      flexWrap: "wrap",
      alignItems: "stretch",
      "& .bannerCard:nth-of-type(1), & .bannerCard:nth-of-type(4)": {
        transform: "translateY(0) !important",
      },
    },
    "@media(max-width:768px)": {
      gap: "15px",
    },
  },
  salesSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "50%",
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& .bannerDescription": {
      margin: "24px 0",
      "@media only screen and (max-width: 768px)": {
        margin: "24px 0",
      },
      "@media only screen and (max-width: 600px)": {
        margin: "20px 0",
      },
    },
  },
  aiSectionRight: {
    width: "50%",
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      paddingTop: "20%",
      "& img": {
        transform: "translateY(1%)!important",
      },
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      paddingTop: "0",
      maxWidth: "500px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
    "& img": {
      transform: "translateY(25%)",
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },

  bussinessSuccesSection: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${bussinessSuccessbg})`,
    paddingTop: "100px",
    position: "relative",
    "& .logos-container": {
      background: "transparent",
      "&::before,&::after": {
        display: "none",
      },
      "& .logo": {
        backgroundColor: "#208EEC26",
        color: "#B6DDFF",
        "& img": {
          width: "48px",
          height: "48px",
        },
      },
      "@media only screen and (max-width: 768px)": {
        paddingBottom: "20px!important",
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "80px",
      backgroundPositionX: "center",
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "40px 0",
    },
  },
  bussinessSuccessContainer: {
    display: "flex",
    alignItems: "center",
    maxWidth: "1200px",
    margin: "0 auto",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  integrationHeaderItem: {
    width: "100%",
    marginBottom: "90px",
    "& h2": {
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& h2": {
        paddingRight: "40px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
      "& h2": {
        textAlign: "center",
        paddingRight: "0",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& h2": {
        textAlign: "center",
      },
    },
  },
  statsContainer: {
    display: "flex",
    alignItems: "stretch",
    flexWrap: "wrap",
    gap: "18px",
    justifyContent: "flex-start",
    width: "100%",
    marginTop: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
      marginTop: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      marginTop: "25px",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "15px",
      marginTop: "20px",
      position: "relative",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "12px",
      marginTop: "15px",
    },
  },
  customerExperencesBox: {
    width: "32%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "50px",
    background: "#002c51",
    borderRadius: "15px",
    padding: "20px",
    minHeight: "230px",
    backdropFilter: "blur(30px) brightness(0.8)",
    overflow: "hidden",

    "& p:nth-child(2)": {
      color: "#D1E4F1",
    },
    "& p:last-child": {
      color: "#D1E4F1",
    },
    "@media only screen and (max-width: 1024px)": {
      width: "31%",
      gap: "30px",
      padding: "18px",
      minHeight: "200px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "48%",
      gap: "25px",
      padding: "16px",
      minHeight: "180px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      padding: "15px",
      borderRadius: "20px",
      minHeight: "max-content",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "12px",
      gap: "12px",
    },
    "&.orangeCard1": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard3": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard5": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard7": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.blueCard3": {
      background: "rgba(0, 154, 153, 0.4)",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #1ADAD9 50%, #00aa7c 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard0": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard2": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard4": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard6": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.greenCard7": {
      background: "#002C51",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #208EEC 50%, #002C51 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    overflow: "auto",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "5px",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px",
    },
  },
  tabCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "32px",
    gap: "40px",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
    },
  },
  tabCardLeftContainer: {
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    alignItems: "flex-start",
    "@media only screen and (max-width: 768px)": {
      alignItems: "center",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    width: "24px!important",
    "& img": {
      width: "100%",
      marginTop: "6px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "24px!important",
    },
  },

  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 1024px)": {
      "& .centerContainer": {
        width: "90%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& .centerContainer": {
        width: "95%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        gap: "16px",
      },
    },
  },
  wpFaq: {
    "& section": {
      padding: "0px 0 40px !important",
    },

    "@media only screen and (max-width: 1024px)": {
      "& section": {
        padding: "0px 0 35px !important",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& section": {
        padding: "0px 0 30px !important",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 40px !important",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& section": {
        padding: "0px 0 25px !important",
      },
    },
  },
  integrationSection: {},
  integrationHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: "70px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& div": {
      width: "50%",
      "@media only screen and (max-width: 768px)": {
        width: "100%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .buttonContaienr": {
      marginTop: "42px",
      "@media only screen and (max-width: 1024px)": {
        marginTop: "35px",
      },
      "@media only screen and (max-width: 768px)": {
        marginTop: "30px",
      },
      "@media only screen and (max-width: 600px)": {
        marginTop: "20px",
      },
      "@media only screen and (max-width: 480px)": {
        marginTop: "15px",
      },
      "& a": {
        color: "#FF682A",

        "&:hover": {
          color: "#fff",
        },
      },
    },
  },
  integrationRightImage: {
    width: "100%",
  },
  combineSection: {
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      marginTop: "40px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
    },
    "@media only screen and (max-width: 480px)": {
      marginTop: "20px",
    },
  },
  adaptSlider: {
    padding: "15px 0!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "15px 4rem 50px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "15px 2rem 40px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "15px 10px 30px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
    "@media only screen and (max-width: 768px)": {
      position: "static",
      transform: "translate(0, 0)",
    },
  },
  bannerPoint: {
    display: "flex",
    flexDirection: "column",
    gap: "22px",
    marginBottom: "20px",
    "@media only screen and (max-width: 1024px)": {
      gap: "20px",
      marginBottom: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "18px",
      marginBottom: "16px",
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      gap: "16px",
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "14px",
      marginBottom: "12px",
    },
  },
  banerPointItem: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    "&:last-child": {
      marginBottom: "42px",
    },
    "& img": {
      width: "32px",
      height: "32px",
    },
    "&:last-child": {
      marginBottom: "40px",
    },
    "@media only screen and (max-width: 1024px)": {
      gap: "14px",
      "& img": {
        width: "30px",
        height: "30px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      "& img": {
        width: "28px",
        height: "28px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      gap: "10px",
      "& img": {
        width: "26px",
        height: "26px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
      "& img": {
        width: "24px",
        height: "24px",
      },
    },
  },
  salesCrmCarousel: {
    backgroundImage: `url(${salesCrmCarouselbg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "65px",
    "& .header-section": {
      flexDirection: "column",
      width: "55%",
      "& h2": {
        marginBottom: "32px",
      },
      "& p": {
        marginBottom: "0",
      },
      "@media(max-width:768px)": {
        width: "100%",
        "& h2": {
          marginBottom: "20px",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingBottom: "60px",
      "& .header": {
        width: "60%",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingBottom: "50px",
      "& .header": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px",
      "& .header": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingBottom: "30px",
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "180px",
      paddingBottom: "70px",
      "& .header": {
        width: "80%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "150px",
      paddingBottom: "60px",
      "& .header": {
        width: "90%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& .container:first-child": {
        padding: "0px 15px",
      },
      "& .header": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingTop: "500px",
      paddingBottom: "30px",
      "& .header": {
        gap: "16px",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  experienceContainer: {
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 1024px)": {
        width: "80%",
      },
      "@media only screen and (max-width: 768px)": {
        width: "90%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
  },
  experienceInnerContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "20px",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      marginTop: "0",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
  },
  experienceContainerLeft: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
    "& .exp-desc": {
      marginBottom: "24px",
    },
    "& .view-more-link": {
      textDecoration: "underline",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      color: "#1D6FB6",
      marginBottom: "20px",
      "& img": {
        display: "inline-block!important",
        width: "16px!important",
        height: "16px",
        marginTop: "3px!important",
        transition: "transform 0.5s ease",
      },
      "&:hover": {
        color: "#010F1D",
        "& img": {
          transform: "translateX(5px)",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      gap: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      gap: "24px",
      alignItems: "center",
      textAlign: "center",
      "& .exp-desc": {
        marginBottom: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginTop: "0px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "18px",
    },
  },
  experienceContainerRight: {
    width: "60%",
    minHeight: "450px",
    "& img": {
      width: "100%",
      height: "100%",
    },
    "@media only screen and (max-width: 768px)": {
      display: "none",
    },
  },
  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  collapseBody: {
    margin: "0",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0  ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },

  accordianTabs: {
    paddingBottom: "300px",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      paddingBottom: "250px",
    },
    "@media only screen and (max-width: 768px)": {
      paddingBottom: "0",
    },

    "& .headercenterContainer": {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      marginBottom: "64px",
      gap: "100px",
      "& h2": {
        width: "50%",
      },
      "& p": {
        width: "40%",
      },
      "@media (max-width:768px)": {
        flexDirection: "column",
        gap: "20px",
        marginBottom: "55px",
        "& h2": {
          width: "100%",
        },
        "& p": {
          width: "100%",
        },
      },
    },
  },
  realWorldTabs: {
    backgroundImage: `url(${realWorldbg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingTop: "300px",
    "& .container": {
      padding: "0 0 120px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "250px",
      "& .container": {
        padding: "0 24px 65px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      padding: "65px 15px",
      "& .container": {
        padding: "0 15px ",
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "40px 15px",
      "& .container": {
        padding: "0",
      },
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
      "& h2": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 1200px)": {
      "& .centerContainer": {
        "& h2": {
          width: "100%",
        },
      },
    },
  },

  adaptsBox: {
    gap: "24px",
    display: "flex!important",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    height: "auto!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "20px",
      maxWidth: "350px",
      gap: "14px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "18px",
      maxWidth: "320px",
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "12px",
      maxWidth: "85%",
      gap: "10px",
    },
  },
  adaptDescription: {
    gap: "10px",
    minHeight: "80px",
    "@media only screen and (max-width: 1024px)": {
      minHeight: "70px",
    },
    "@media only screen and (max-width: 768px)": {
      minHeight: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      alignItems: "baseline",
      minHeight: "auto",
    },
    "@media only screen and (max-width: 480px)": {
      minHeight: "auto",
    },
  },
  adaptBoxImg: {
    width: "48px",
    maxWidth: "48px",
    position: "relative",
    bottom: "0",
    marginBottom: "24px",
    "@media only screen and (max-width: 1024px)": {
      width: "44px",
      maxWidth: "44px",
      marginBottom: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "40px",
      maxWidth: "40px",
      marginBottom: "18px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "36px",
      maxWidth: "36px",
      marginBottom: "16px",
    },
    "@media only screen and (max-width: 480px)": {
      width: "32px",
      maxWidth: "32px",
      marginBottom: "14px",
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  integrationLeft: {
    "@media only screen and (max-width: 768px)": {
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      textAlign: "left",
    },
  },
  integrationRight: {
    "@media only screen and (max-width: 768px)": {
      maxWidth: "500px",
      margin: "0 auto",
    },
    "@media only screen and (max-width: 600px)": {
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
  },

  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  broadcastBox: {
    padding: "32px 32px 0",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "0 auto",

    "& img": {
      maxWidth: "80%",
      width: "auto",
      height: "auto",
      margin: "24px auto 0",
      display: "table",
      "@media(max-width: 768px)": {
        width: "auto",
        maxWidth: "auto",
      },
      "@media(max-width: 768px)": {
        width: "auto",
        maxWidth: "90%",
        height: "auto",
      },
    },
  },
  designCrmCarousel: {
    backgroundColor: "#e9f4fd",
    "& .designHeader": {
      maxWidth: "55%",
      "& h2": {
        marginBottom: "24px",
      },
      "& p": {
        marginBottom: "16px",
        fontSize: "20px",
      },
      "@media(max-width:768px)": {
        maxWidth: "100%",
      },
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
      "& .swiper-slide": {
        height: "auto!important",
      },
    },
    "@media(max-width:768px)": {
      "& .swiper-wrapper": {
        padding: "0 24px ",
      },
    },
    ".swiper-slide": {
      width: "100%!important",
    },
  },
  broadcastContainerInner: {
    display: "flex",
    flexDirection: "column-reverse",
    paddingBottom: "86px",
    "@media(max-width:1024px)": {
      padding: "0 50px 32px!important",
    },
    "@media(max-width:600px)": {
      padding: "0 0 32px!important",
    },
    "& .swiper-button-prev": {
      top: "100px !important",
      left: "auto",
      right: "200px",
      color: "#010f1d",
      width: "78px",
      height: "78px",
      borderRadius: "50%",
      border: "2px solid #53677c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:after": {
        fontSize: "24px",
      },
    },
    "& .swiper-button-next": {
      top: "100px !important",
      right: "100px",
      color: "#010f1d",
      width: "78px",
      height: "78px",
      borderRadius: "50%",
      border: "2px solid #53677c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:after": {
        fontSize: "24px",
      },
    },
  },
  faqBoxAccordian: {
    padding: "0 16px",
    backgroundColor: "#fff",
    borderRadius: "16px",
    position: "relative",
    transition: "all 0.3s ease",
    cursor: "pointer",
    "& h3": {
      color: "#0A2035",
      opacity: "0.7",
    },
    "&:after": {
      content: '""',
      position: "absolute",
      left: "0",
      top: "0",
      width: "2px",
      height: "100%",
      background: "rgba(0, 0, 0, 0.2)",
    },
    "&:before": {
      content: '""',
      position: "absolute",
      background: "#B1DBFF",
      background:
        "linear-gradient(180deg,rgba(177, 219, 255, 1) 16%, rgba(0, 137, 255, 1) 75%, rgba(0, 137, 255, 1) 80%)",
      left: "-1px",
      top: "0",
      width: "4px",
      height: "100%",
      transform: "scaleY(0)",
      transformOrigin: "top",
      zIndex: 1,
    },
    "&.active": {
      "& h3": {
        color: "#0A2035",
        opacity: "1",
      },
      "&:before": {
        animation: "growTimer 10s linear forwards", // Same as JS interval
      },
    },
    "& .body": {
      margin: "0",
    },
    "& .exp-desc": {
      margin: "10px 0 16px",
    },
  },
  experienceHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  testimonials: {
    background: "#FCF8FF",
    paddingBottom: "50px",
    "@media(max-width:1025px)": {
      paddingBottom: "24px",
    },
  },
  smallCardContainer: {
    marginTop: "30px",
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    "& $cardContainer": {
      width: "32%",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      marginTop: "16px",
      gap: "15px",
      "& $cardContainer": {
        height: "400px",
        width: "100%",
        padding: "16px",
      },
    },
  },
  cardContainer: {
    borderRadius: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "18px",
    padding: "25px",
    background: "rgba(0, 44, 81, 0.4)",
    backdropFilter: "blur(20px)",
    height: "320px",
    position: "relative",
    overflow: "hidden",
    "&.greenCard": {
      background: "#014957",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #028BA6 60%, #014957 100%)",
          borderRadius: "50%",
          filter: "blur(80px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.purpleCard": {
      background: "#41086E",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "400px",
          height: "400px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 30%, #B458FF 50%)",
          borderRadius: "50%",
          filter: "blur(200px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.blueCard": {
      background: "#026f85",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background:
            "radial-gradient(circle,rgb(5, 182, 217) 80%, #026f85 100%)",
          borderRadius: "50%",
          filter: "blur(80px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard": {
      background: "rgb(0, 45, 81)",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #3ac4ff 30%, #1f79d3 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "@media(max-width:1024px)": {
      "&.bannerCard": {
        width: "48%",
        minWidth: "48%",
        height: "auto",
      },
    },
    "@media(max-width:992px)": {
      "&.bannerCard": {
        width: "48%",
        minWidth: "48%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
    "@media(max-width:600px)": {
      padding: "16px",
      gap: "8px",
      "&.bannerCard": {
        width: "48%",
        minWidth: "46%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
    "@media(max-width:400px)": {
      padding: "16px",
      gap: "8px",
      "&.bannerCard": {
        width: "47%",
        minWidth: "46%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
  },
  Client: {
    position: "relative",
    zIndex: "10",
    margin: "-24px 0",
    "@media(max-width:1024px)": {
      margin: "0",
    },
    "& .container": {
      paddingTop: "0",
      "@media(max-width:1024px)": {
        padding: "65px 25px",
        "& .client-logo": {
          "& img": {
            width: "auto",
            height: "30px",
          },
        },
      },
      "@media(max-width:768px)": {
        "& .client-logo": {
          "& img": {
            width: "auto",
            height: "25px",
          },
        },
      },

      "@media(max-width:600px)": {
        padding: "40px 15px",
        "& .client-logo": {
          "& img": {
            width: "auto",
            height: "20px",
          },
        },
      },
    },
    "& p": {
      textAlign: "center",
      marginBottom: "32px",
    },
    "& .client-logo": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        width: "auto",
        height: "30px",
      },
    },
  },
  broadcastheader: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
  },
  cardHeader: {
    "& p": {
      lineHeight: "1",
    },
  },
}));

const AUTO_PLAY_INTERVAL = 10000;

const experienceList = [
  {
    title: "Centralise service pipelines and track delivery",
    alt: "Check how pipeline works",
    lintText: "Check how pipeline works",
    linkUrl: "https://www.peppercloud.com/features/sales-pipeline-crm",
    img: experienceImg2,
    alt: "Pepper Cloud CRM opportunity pipeline with sales stages.",
    desc: "Get a complete view of service workflows with custom pipelines. Monitor ticket progress, team responsibilities, and delivery timelines with ease. Perfect for IT service providers and tech teams managing multiple clients or projects.",
  },
  {
    title: "Make faster decisions with real-time insights",
    alt: "Try Analytics",
    lintText: "Try Analytics",
    linkUrl: "https://peppercloud.com/sales-dashboard/",
    img: experienceImg3,
    desc: "Use built-in analytics to monitor SLA compliance, project bottlenecks, and client satisfaction. Pepper Cloud helps IT CRM users stay on top of key performance metrics—driving smarter decisions, faster.",
  },
  {
    title: "Automate repetitive IT workflows",
    alt: "Explore AssistAI",
    lintText: "Explore AssistAI",
    linkUrl:
      "https://peppercloud.com/sales-crm-features/ai-crm-tool-for-small-business/",
    img: experienceImg4,
    desc: "Simplify daily operations by automating ticket assignments, task follow-ups, and client updates. Pepper Cloud offers CRM software for IT services with workflow automation and AssistAI to cut manual work and save hours.",
  },
  {
    title: "Unify conversations across all client channels",
    alt: "CRM Integrations",
    lintText: "CRM Integrations",
    linkUrl: "https://peppercloud.com/crm-integrations",
    img: experienceImg5,
    desc: "Manage WhatsApp, emails, and calls in one place. With omnichannel communication tools, tech teams can deliver prompt, personalised support at scale—making Pepper Cloud a trusted CRM for IT support.",
  },
  {
    title: "Deliver and collaborate from anywhere",
    alt: "Explore mobile CRM",
    lintText: "Explore mobile CRM",
    linkUrl: "https://play.google.com/store/apps/details?id=com.peppercloud",
    img: experienceImg6,
    desc: "With mobile-first access, your tech team can update tasks, track issues, and respond to clients even on the go. Built for remote work, Pepper Cloud is a truly modern technical CRM for dynamic IT teams.",
  },
];
const tabContentData = [
  {
    tabContent: [
      {
        heading: "Seamless API integrations",
        content: "Connect easily with internal tools and apps.",
        alt: "Seamless API integrations",
      },
      {
        heading: "Role-based access",
        content: "Manage permissions across sales, support, and admin teams.",
        alt: "Role-based access",
      },
      {
        heading: "Data sync automation",
        content: "Ensure lead and deal data stays up to date across platforms.",
        alt: "Data sync automation",
      },
      {
        heading: "Webhook triggers",
        content: "Automate actions based on CRM updates in real time.",
        alt: "Webhook triggers",
      },
    ],
    image: realWorldImage2,
    alt: " SaaS companies",
    subtitle:
      "IT teams in SaaS focus on integrations, data flow, and platform performance. Pepper Cloud ensures reliable APIs, user access control, and real-time data sync.",
  },
  {
    tabContent: [
      {
        heading: "Custom pipeline stages",
        content: "Track service requests from start to resolution.",
        alt: "Custom pipeline stages",
      },
      {
        heading: "Automated SLA alerts",
        content: "Trigger reminders before response deadlines.",
        alt: "Automated SLA alerts",
      },
      {
        heading: "Multi-channel support view",
        content: "See all client interactions in one place.",
        alt: "Multi-channel support view",
      },
      {
        heading: "Audit logs",
        content: "Monitor system access and changes for compliance.",
        alt: "Audit logs",
      },
    ],
    image: realWorldImage3,
    alt: "Managed service providers (MSPs)",
    subtitle:
      "MSPs require strong ticketing, client tracking, and SLA compliance. Pepper Cloud helps IT teams streamline service delivery with better visibility and automation.",
  },
  {
    tabContent: [
      {
        heading: "Data encryption at rest",
        content: "Ensure security of client and transaction records.",
        alt: "Data encryption at rest",
      },
      {
        heading: "Flexible user management",
        content: "Create access rules for dev, ops, and sales teams.",
        alt: "Flexible user management",
      },
      {
        heading: "Custom module creation",
        content: "Build fields and workflows unique to your tech stack.",
        alt: "Custom module creation",
      },
      {
        heading: "Monitoring dashboards",
        content: "Track system events, lead flow, and errors visually.",
        alt: "Monitoring dashboards",
      },
    ],
    image: realWorldImage4,
    alt: "Fintech companies",
    subtitle:
      "Tech teams in fintech demand secure, scalable systems with strict data policies. Pepper Cloud offers enterprise-grade CRM capabilities to support technical operations.",
  },
  {
    tabContent: [
      {
        heading: "Quick setup and onboarding",
        content: "Go live in days without heavy dev work.",
        alt: "Quick setup and onboarding",
      },
      {
        heading: "Low-code workflow builder",
        content: "Automate tasks without writing code.",
        alt: "Low-code workflow builder",
      },
      {
        heading: "Third-party integrations",
        content: "Connect with tools like Slack, Stripe, and Zoom.",
        alt: "Third-party integrations",
      },
      {
        heading: "Sandbox environment",
        content: "Test updates safely before going live.",
        alt: "Sandbox environment",
      },
    ],
    image: realWorldImage5,
    alt: "Product startups",
    subtitle:
      "Early-stage startups rely on lean tech teams to build and support growth tools. With Pepper Cloud, they get a no-code CRM that’s easy to deploy and scale.",
  },
  {
    tabContent: [
      {
        heading: "Client-specific pipelines",
        content: "Track projects, consultations, and renewals.",
        alt: "Client-specific pipelines",
      },
      {
        heading: "Email and call sync",
        content: "Log every conversation for future reference.",
        alt: "Email and call sync",
      },
      {
        heading: "Proposal follow-up workflows",
        content: "Auto-remind clients about pending approvals.",
        alt: "Proposal follow-up workflows",
      },
      {
        heading: "Knowledge base access",
        content: "Share product guides or SOPs with teams.",
        alt: "Knowledge base access",
      },
    ],
    image: realWorldImage6,
    alt: " IT consulting firms",
    subtitle:
      "IT consultants manage multiple client systems, proposals, and handovers. Pepper Cloud helps them centralise data, automate follow-ups, and document everything.",
  },
];
const SalesMangers = () => {
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const classes = useStyles();
  const sectionRef = useRef(null);
  const [userSelected, setUserSelected] = useState(false);

  useEffect(() => {
    let interval;

    const startAutoplay = () => {
      clearInterval(interval);
      interval = setInterval(() => {
        setActiveAccordian((prev) => (prev + 1) % experienceList.length);
      }, AUTO_PLAY_INTERVAL);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          startAutoplay();
        } else {
          clearInterval(interval);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      clearInterval(interval);
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [experienceList.length]);

  // When user clicks on an accordion
  const handleAccordionClick = (index) => {
    setActiveAccordian(index);
    setUserSelected(true);

    // Restart autoplay so the full interval is shown after click
    // Without resetting to the next immediately
    clearInterval(intervalId);
    intervalId = setInterval(() => {
      setActiveAccordian((prev) => (prev + 1) % experienceList.length);
    }, AUTO_PLAY_INTERVAL);
  };

  //card height
  useEffect(() => {
    const updateCardHeights = () => {
      const cards = document.querySelectorAll(".bannerCard");

      cards.forEach((card) => {
        if (window.innerWidth <= 1024) {
          card.style.height = "auto"; // let it size naturally
        } else {
          const originalHeight = card.offsetHeight;
          card.style.height = `${originalHeight}px`; // add 100px
        }
      });
    };

    // Run on mount
    updateCardHeights();

    // Run on resize
    window.addEventListener("resize", updateCardHeights);
    return () => window.removeEventListener("resize", updateCardHeights);
  }, []);

  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}:first-child`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.blueCard`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard`
      ),
    ];

    const setupCard = (card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150;
        const topRightY = 0;

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      card.handlers = handlers;

      card.addEventListener("mousemove", handlers.mousemove);
      card.addEventListener("mouseenter", handlers.mouseenter);
      card.addEventListener("mouseleave", handlers.mouseleave);
      window.addEventListener("resize", handlers.resize);
    };

    cardsToAnimate.forEach(setupCard);

    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card?.handlers) return;

        const { handlers } = card;
        card.removeEventListener("mousemove", handlers.mousemove);
        card.removeEventListener("mouseenter", handlers.mouseenter);
        card.removeEventListener("mouseleave", handlers.mouseleave);
        window.removeEventListener("resize", handlers.resize);
      });
    };
  }, [classes]);

  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 2) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 20 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollPosition(currentScrollY);
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // setSubMenuOpen(false);
        // setIsVisible(false);
      } else {
        // setSubMenuOpen(false);
        // setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);
  const { ref, inView } = useInView({
    threshold: 0.5, // adjust as needed
    triggerOnce: false,
  });

  // When the section is in view, set up a timer to auto change the active accordion every 5 seconds.
  const benifitList = [
    {
      img: industryIntegration,
      title: "Why IT and tech teams need a CRM",
      desc: "IT companies handle complex client needs, service SLAs, and technical support processes. Without a central system, data silos, delayed responses, and missed follow-ups are common. A robust CRM for IT support centralises client data, automates ticket flows, and improves coordination between teams. With Pepper Cloud, you deliver faster, smarter, and more reliable technical service.",
    },
  ];
  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      document.querySelector(`.${classes.cardContainer}:first-child`),
      document.querySelector(`.${classes.cardContainer}.blueCard`),
      ...document.querySelectorAll(`.${classes.cardContainer}.regularCard`),
      ...document.querySelectorAll(`.${classes.cardContainer}.purpleCard`),
      ...document.querySelectorAll(`.${classes.cardContainer}.greenCard`), // Add regularCards
    ];

    cardsToAnimate.forEach((card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      // Set initial top-right position for the glass effect
      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150; // Adjust this value to position from right edge
        const topRightY = 0; // Top position

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      // Call it initially
      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      // Store handlers on the card element for cleanup
      card.handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      // Add event listeners
      card.addEventListener("mousemove", handleMouseMove);
      card.addEventListener("mouseenter", handleMouseEnter);
      card.addEventListener("mouseleave", handleMouseLeave);
      window.addEventListener("resize", setInitialPosition);
    });

    // Cleanup
    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card) return;

        const handlers = card.handlers;
        if (handlers) {
          card.removeEventListener("mousemove", handlers.mousemove);
          card.removeEventListener("mouseenter", handlers.mouseenter);
          card.removeEventListener("mouseleave", handlers.mouseleave);
          window.removeEventListener("resize", handlers.resize);
        }
      });
    };
  }, [classes]);
  const faqs = [
    {
      question: "What is the best CRM for IT and tech teams in 2025?",
      answer: (
        <>
          Pepper Cloud CRM is among the best CRM platforms for IT and tech teams
          due to its automation, multichannel support, custom workflows, and
          scalability. It’s ideal for IT service providers, software companies,
          and managed service teams.
        </>
      ),
    },
    {
      question: "How can a CRM help IT and tech teams streamline operations?",
      answer: (
        <>
          A CRM helps by centralising client communication, automating ticket
          workflows, tracking project progress, and offering real-time insights
          for faster decision-making. It reduces manual work and improves
          service quality.
        </>
      ),
    },
    {
      question: "What are the key benefits of CRM for IT and tech teams?",
      answer: (
        <>
          The main <strong>benefits of CRM for IT and tech teams</strong>{" "}
          include better team collaboration, faster ticket resolution, improved
          client satisfaction, workflow automation, and real-time data for
          service optimisation.
        </>
      ),
    },
    {
      question: "How to use CRM for IT and tech teams effectively?",
      answer: (
        <>
          To use a CRM effectively, start by mapping your service workflows.
          Automate ticket routing and client follow-ups, integrate communication
          tools like WhatsApp or Slack, and use dashboards to track SLA
          compliance and project health.
        </>
      ),
    },
    {
      question: "Can CRM software manage IT support tickets and SLAs?",
      answer: (
        <>
          Yes. With Pepper Cloud CRM, you can create pipelines for ticket
          resolution, assign tasks, track SLA metrics, and send automated
          updates to clients—all in one dashboard.
        </>
      ),
    },
    {
      question: "Does Pepper Cloud CRM integrate with other IT tools?",
      answer: (
        <>
          Absolutely. Pepper Cloud CRM integrates with tools like Gmail,
          Outlook, WhatsApp, Slack, and calendar apps, making it ideal for IT
          professionals who rely on a connected tech stack.
        </>
      ),
    },
    {
      question:
        "Is CRM only for sales teams or also useful for service teams in tech?",
      answer: (
        <>
          CRM is no longer just for sales. IT and service teams use CRM to
          manage client relationships, track project statuses, automate service
          flows, and collaborate internally—all of which improve service
          delivery and client retention.
        </>
      ),
    },
    {
      question: "Can IT startups and small tech agencies use CRM software?",
      answer: (
        <>
          Yes. Pepper Cloud CRM is designed for SMEs, making it a perfect fit
          for IT startups, freelance tech consultants, and growing tech agencies
          with limited resources but high client engagement needs.
        </>
      ),
    },
    {
      question: "How secure is client data in a CRM system?",
      answer: (
        <>
          With Pepper Cloud, your client and project data is protected with
          encryption, role-based access controls, and secure cloud
          storage—ensuring full compliance and peace of mind.
        </>
      ),
    },
    {
      question: "How do I choose the best CRM for my tech company?",
      answer: (
        <>
          Look for a CRM with custom workflows, automation, multichannel
          support, mobile access, and strong integrations. Pepper Cloud ticks
          all these boxes, making it the best CRM for IT and tech teams in 2025.
        </>
      ),
    },
  ];
  const adaptList = [
    {
      pointer: "Effortless implementation",
      desc: "Start fast with simple onboarding for IT workflows, adding clients, tasks, opportunities.",
      img: salesImg1,
      alt: "Effortless implementation",
    },
    {
      pointer: "Smart automation",
      desc: "Automate routing, reminders, alerts, and updates to reduce manual work, accelerate resolutions.",
      img: salesImg2,
      alt: "Smart automation",
    },
    {
      pointer: "Project tracking",
      desc: "Stay on top of service requests and milestones using visual dashboards and progress boards.",
      img: salesImg3,
      alt: "Project tracking",
    },
    {
      pointer: "Mobile-ready for remote teams",
      desc: "Update tickets, track issues, and respond from any device, ideal for field and hybrid IT teams.",
      img: salesImg4,
      alt: "Mobile-ready for remote teams",
    },
    {
      pointer: "Scalable for all tech teams",
      desc: "Built to grow with you, whether you’re a 5-member dev shop or an enterprise IT service provider.",
      img: salesImg5,
      alt: "Scalable for all tech teams",
    },
    {
      pointer: "Always-on technical support",
      desc: "Reach our expert team anytime via chat, email, or phone—so your operations never pause.",
      img: salesImg6,
      alt: "Always-on technical support",
    },
  ];

  const clientList = [
    {
      img: adaptImg1,
    },
    {
      img: adaptImg2,
    },
    {
      img: adaptImg3,
    },
    {
      img: adaptImg4,
    },
    {
      img: adaptImg5,
    },
    {
      img: adaptImg6,
    },
    {
      img: adaptImg7,
    },
    {
      img: adaptImg1,
    },
    {
      img: adaptImg2,
    },
    {
      img: adaptImg3,
    },
    {
      img: adaptImg4,
    },
    {
      img: adaptImg5,
    },
    {
      img: adaptImg6,
    },
    {
      img: adaptImg7,
    },
  ];

  // sales rep contents
  const bannerPoints = [
    "AI-powered sales insights",
    "WhatsApp CRM for real-time communication",
    "Smart sales automation and reminders",
    "Customisable sales pipelines and activity tracking",
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    " Zoho CRM",
    "Freshsales CRM",
    "EngageBay CRM ",
    "Monday CRM",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM is the best CRM for IT and tech teams, offering automation, multichannel support, and deep customisation for tech workflows. Built for service delivery, it centralises customer data, streamlines project tracking, and improves team collaboration.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "Multichannel integration",
          desc: "Manage client conversations across email, WhatsApp, and calls for efficient communication.",
        },
        {
          title: "Workflow automation",
          desc: "Automate ticket assignments, task updates, and follow-up messages.",
        },
        {
          title: "Analytics and reporting",
          desc: "Track ticket resolution time, client satisfaction, and project metrics.",
        },
        {
          title: "Mobile CRM",
          desc: "Manage tasks and support tickets on the go with a full-featured mobile app.",
        },
        {
          title: "Customisable workflows",
          desc: "Adapt the CRM to your IT processes with flexible, scalable modules.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM helps IT companies manage leads, automate support processes, and integrate with their existing tech stack.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Email and chat automation",
          desc: "Trigger workflows and notifications based on client activity.",
        },
        {
          title: "Third-party integrations",
          desc: "Connect with tools like Jira, Slack, and Office 365.",
        },
        {
          title: "Service pipelines",
          desc: "Track issue progress and client escalations across departments.",
        },
      ],
    },
    {
      title: "Freshsales CRM",
      desc: "Freshsales by Freshworks supports IT teams with smart automation, client segmentation, and fast deployment.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Multichannel communication",
          desc: "Centralise client communication across email, phone, and chat.",
        },
        {
          title: "AI-powered insights",
          desc: "Identify at-risk clients and optimise your response strategies.",
        },
        {
          title: "Task management",
          desc: "Automate internal tasks and update statuses instantly.",
        },
      ],
    },
    {
      title: "EngageBay CRM",
      desc: "EngageBay offers a unified platform for support, sales, and marketing—ideal for startups and small tech agencies.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Support ticketing",
          desc: "Log and track customer issues from submission to resolution.",
        },
        {
          title: "Client segmentation",
          desc: "Personalise engagement based on service history.",
        },
        {
          title: "Workflow automation",
          desc: "Automate reminders, escalations, and ticket updates.",
        },
      ],
    },
    {
      title: "Monday CRM",
      desc: "Monday CRM provides a highly customisable platform for managing IT projects, workflows, and client interactions.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "Unified platform",
          desc: "Manage service requests, team tasks, and documentation from one place.",
        },
        {
          title: "Custom dashboards",
          desc: "Create reports for SLAs, project timelines, and performance metrics.",
        },
        {
          title: "Tool integration",
          desc: "Sync with GitHub, Google Drive, and calendar tools for better coordination.",
        },
      ],
    },
  ];
  const broadcastList = [
    {
      pointer: "CRM for sales development reps",
      card: {
        pointer: [
          "Qualify leads, automate outreach, and book meetings faster with integrated calling and task tools.",
        ],
        img: broadcastImg2,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: "#014957",
        backgroundImage: "linear-gradient(to bottom, #014957, #028ba6)",
      },
    },
    {
      pointer: "CRM for marketing teams",
      card: {
        pointer: [
          "Launch campaigns and capture more leads with ease while tracking performance in real-time and managing all campaign activities.",
        ],
        img: broadcastImg3,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: " #31114b",
        backgroundImage: "linear-gradient(to bottom, #31114b, #783ca8);",
      },
    },
    {
      pointer: "CRM for customer support teams",
      card: {
        pointer: [
          "Respond faster, manage tickets efficiently, and improve satisfaction with smart support workflows.",
        ],
        img: broadcastImg4,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#2788e7",
        backgroundImage: "linear-gradient(to bottom, #2788e7, #783ca8)",
      },
    },
    {
      pointer: "CRM for business owners",
      card: {
        pointer: [
          "Gain full visibility and control from one platform with real-time insights, revenue trends, and business growth metrics.",
        ],
        img: broadcastImg5,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#09939a",
        backgroundImage: " linear-gradient(to bottom, #09939a, #783ca8)",
      },
    },
    {
      pointer: "CRM for IT and tech teams",
      card: {
        pointer: [
          "Streamline service delivery, automate workflows, and manage client support with ease.",
        ],
        img: broadcastImg1,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: " #0A2F4F",
        backgroundImage: " linear-gradient(180deg, #0A2F4F 0%, #2576BB 100%)",
      },
    },
  ];

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <main>
      <SEO
        description={
          "Discover the best CRM for IT and tech teams. Streamline operations, automate workflows, and improve service delivery with Pepper Cloud CRM."
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the role of CRM in retail?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Retail CRM plays a crucial role in managing customer interactions, tracking sales, and enhancing service across both online and offline channels.",
                },
              },
              {
                "@type": "Question",
                name: "Why is a specialized CRM necessary for e-commerce?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A specialized e-commerce CRM addresses challenges such as cart abandonment, personalized recommendations, and multichannel support, ultimately enhancing customer experience and driving sales.",
                },
              },
              {
                "@type": "Question",
                name: "Is investing in a CRM worthwhile for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is beneficial for small e-commerce businesses as it improves customer service, streamlines operations, and enables data-driven decision-making, leading to growth and increased profitability.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud assist with cart abandonment?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM automates cart abandonment recovery through targeted reminders and incentives, resulting in increased conversions.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud facilitate multichannel sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM offers omnichannel capabilities, managing sales and customer interactions across websites, marketplaces, and social media platforms for a unified customer view.",
                },
              },
            ],
          },
        ]}
        keywords="Crm for it,crm for it company​,crm software for it services,crm for it service providers,crm for it support,It crm ,technical crm"
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        pathname={"https://peppercloud.com/teams/best-crm-for-sales-reps/"}
        title={" Best CRM for IT and tech teams | Streamline operations"}
      />

      <div className={clsx(classes.SalesMangerSection, "sales-hero-section")}>
        <div className="container">
          <div className={classes.SalesMangerContainer}>
            <motion.div
              className={classes.heroContent}
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              <h1 className="font-wix-semibold font-64 ">
                Best CRM for IT and innovative tech teams
              </h1>
              <p className="font-wix-regular font-18">
                Pepper Cloud offers the best CRM for IT and tech teams to
                streamline service delivery, automate workflows, and manage
                client support with ease. Whether you're a startup or an
                established IT service provider, our platform is built to scale
                with your growth.
              </p>
              <div className="buttonContainer">
                <Link
                  className=" primaryButton font-inter-medium font-18 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  to={"/contact/"}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Book a free demo
                </Link>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 1, y: 60 }}
              transition={{ duration: 0.75 }}
              whileInView={{ opacity: 1, y: 0 }}
              className={classes.bannerCards}
            >
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  "blueCard"
                )}
                // onMouseEnter={() => !isMobile && setIsHovering3(true)}
                // onMouseLeave={() => !isMobile && setIsHovering3(false)}
              >
                <img src={bannerIcon1} />
                <h3 className="font-wix-semibold font-20 font-white">
                  Custom workflows
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Build and customise service workflows to match your IT
                  processes, from ticket handling to task approvals.
                </p>
              </div>
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  "regularCard"
                )}
                // onMouseEnter={() => !isMobile && setIsHovering4(true)}
                // onMouseLeave={() => !isMobile && setIsHovering4(false)}
              >
                <img src={bannerIcon2} />
                <h3 className="font-wix-semibold font-20 font-white">
                  Automated support
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Automatically assign support tickets, trigger updates, and
                  streamline communication with clients and teams.
                </p>
              </div>
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  " purpleCard"
                )}
                // onMouseEnter={() => !isMobile && setIsHovering5(true)}
                // onMouseLeave={() => !isMobile && setIsHovering5(false)}
              >
                <img src={bannerIcon3} />
                <h3 className="font-wix-semibold font-20 font-white">
                  Service dashboards
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Track project status, SLAs, and service metrics in real time
                  through visual, easy-to-read dashboards.
                </p>
              </div>
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  " greenCard  "
                )}
                // onMouseEnter={() => !isMobile && setIsHovering5(true)}
                // onMouseLeave={() => !isMobile && setIsHovering5(false)}
              >
                <img src={bannerIcon4} />
                <h3 className="font-wix-semibold font-20 font-white">
                  Secure collaboration
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Control access with role-based permissions and ensure data
                  privacy across your IT support operations.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      <section className={classes.Client}>
        <div className="container">
          <p className="font-24 font-wix-semibold">
            Trusted by leading businesses for outstanding efficiency
          </p>
          <Swiper
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            breakpoints={{
              // For smaller screens (mobile)
              0: {
                slidesPerView: 2,
                freeMode: true,
                // grabCursor: false,
                spaceBetween: 40,
                slidesPerGroup: 1,
                // autoplay: false,
                // modules: [],
              },
              // For larger screens (desktop)
              768: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 40,
              },
              1200: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 40,
              },
            }}
            className={classes.adaptSlider}
            grabCursor={true}
            loop={true}
            modules={[Autoplay]}
            speed={2500}
            slidesPerView={"auto"}
            // centeredSlides={true}
            spaceBetween={30}
          >
            {clientList.map((point) => (
              <SwiperSlide className="client-logo">
                <div>
                  <img
                    // alt={point.card.alt}
                    src={point.img}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {benifitList.map((benifit) => (
        <section className={classes.integrationSection}>
          <div className="container">
            <div className={classes.integrationHeader}>
              <div className={classes.integrationLeft}>
                <motion.h2
                  className="font-wix-semibold font-56 color-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {benifit.title}
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18 color-black1 mt20"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {benifit.desc}
                </motion.p>
              </div>
              <div className={classes.integrationRight}>
                <img
                  alt={benifit.title}
                  className={classes.integrationRightImage}
                  src={benifit.img}
                />
              </div>
            </div>
          </div>
        </section>
      ))}

      <section className={classes.salesCrmCarousel}>
        <div className="container">
          <div className="header-section">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Automate support to boost productivity
            </motion.h2>
            <motion.p
              className="font-wix-regular font-18 color-black2"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              IT teams need a powerful tool to automate, integrate, and securely
              scale. Pepper Cloud CRM delivers exactly that with smart, tailored
              features.
            </motion.p>
          </div>
        </div>
        <Swiper
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: 1,
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              slidesPerGroup: 1,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: 2,
              slidesPerGroup: 1,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 4,
              slidesPerGroup: 1,
              spaceBetween: 15,
            },
          }}
          className={classes.adaptSlider}
          grabCursor={true}
          loop={true}
          modules={[Autoplay]}
          speed={5000}
          slidesPerView={"auto"}
          // centeredSlides={true}
          spaceBetween={30}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  // alt={point.card.alt}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold lineHeight-1">
                  {point.pointer}
                </p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <section className={classes.experienceContainer} ref={ref}>
        <section className={classes.accordianTabs}>
          <div className="container">
            <div className="headercenterContainer">
              <motion.h2
                className="font-wix-semibold font-56 text-black1"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Why Pepper Cloud is the best CRM for IT and tech teams
              </motion.h2>
              <p className="font-18 font-wix-regular text-black2">
                Pepper Cloud is the ideal CRM for IT companies that want to
                scale efficiently, automate service workflows, and gain full
                visibility across projects and teams. From managing support
                tickets to tracking client feedback, everything is unified in
                one intelligent, scalable platform.
              </p>
            </div>
            <div className={classes.experienceInnerContainer}>
              <div className={classes.experienceContainerRight}>
                {experienceList.map(
                  (experience, index) =>
                    index === activeAccordian && (
                      <motion.img
                        alt={experience.alt}
                        initial={{ opacity: 1, y: 20 }}
                        src={experience.img}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      />
                    )
                )}
              </div>
              <div className={classes.experienceContainerLeft} ref={sectionRef}>
                {experienceList.map((faq, index) => (
                  <motion.div
                    className={clsx(
                      classes.faqBoxAccordian,
                      index === activeAccordian && "active",
                      "text-color2"
                    )}
                    key={`faq-${index}-${activeAccordian === index}`}
                    onClick={() => setActiveAccordian(index)}
                    transition={{ duration: 1, delay: index * 0.01 }}
                    whileInView={{ opacity: [0, 1], y: [50, 0] }}
                  >
                    <div className={classes.experienceHeader}>
                      <h3 className="font-20 font-wix-semibold">{faq.title}</h3>
                    </div>
                    <Collapse
                      className={classes.collapseBody}
                      in={activeAccordian === index}
                    >
                      <p className="font-18 font-wix-regular color-black2 exp-desc">
                        {faq.desc}
                      </p>
                      <a
                        className="font-18 color-black1 font-wix-regular view-more-link"
                        href={faq.linkUrl}
                      >
                        {faq.lintText}{" "}
                        <img alt="Arrow Right" src={arrowRight} />{" "}
                      </a>
                      <motion.img
                        alt={faq.alt}
                        initial={{ opacity: 1, y: 20 }}
                        src={faq.img}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      />
                    </Collapse>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
          <div className={classes.absoulteCard}>
            <TruestedSection background={true} />
          </div>
        </section>

        <section className={classes.realWorldTabs}>
          <div className="container">
            <div className="centerContainer">
              <motion.h2
                className="font-wix-semibold font-56 color-black1"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Application and use cases of CRM for IT and tech teams
              </motion.h2>
              <div className={classes.tabsContainer}>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-18",
                    activeRealWorld === 0 && "active"
                  )}
                  onClick={() => setActiveRealWorld(0)}
                >
                  SaaS companies
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-18",
                    activeRealWorld === 1 && "active"
                  )}
                  onClick={() => setActiveRealWorld(1)}
                >
                  MSPs
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-18",
                    activeRealWorld === 2 && "active"
                  )}
                  onClick={() => setActiveRealWorld(2)}
                >
                  Fintech companies
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-18",
                    activeRealWorld === 3 && "active"
                  )}
                  onClick={() => setActiveRealWorld(3)}
                >
                  Product startups
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-18",
                    activeRealWorld === 4 && "active"
                  )}
                  onClick={() => setActiveRealWorld(4)}
                >
                  IT consulting firms
                </div>
              </div>
            </div>

            <div className={classes.tabCard}>
              <div className={classes.tabCardLeftContainer}>
                {tabContentData.map(
                  (listItem, index) =>
                    index === activeRealWorld && (
                      <div>
                        <motion.p
                          className="font-wix-regular font-18 color-black2"
                          initial={{ opacity: 0, y: 20 }}
                          transition={{ duration: 0.3 }}
                          whileInView={{ opacity: 1, y: 0 }}
                        >
                          {listItem.subtitle}
                        </motion.p>
                        <div className={classes.benfitListContainer}>
                          {listItem.tabContent.map((item) => (
                            <motion.div
                              className={classes.benfitListItem}
                              initial={{ opacity: 0, y: 20 }}
                              transition={{ duration: 0.3 }}
                              whileInView={{ opacity: 1, y: 0 }}
                            >
                              <LazyImage
                                alt={item.alt}
                                className={classes.benfitIcon}
                                source={bannerTick}
                              />
                              <div className={classes.benfitListItemContent}>
                                <p className="font-wix-semibold font-20 color-black1">
                                  {item.heading}
                                </p>
                                <p className="font-wix-regular font-18 color-black2">
                                  {item.content}
                                </p>
                              </div>
                            </motion.div>
                          ))}
                        </div>
                      </div>
                    )
                )}
              </div>
              <div className={classes.tabCardRightContainer}>
                {tabContentData.map(
                  (listItem, index) =>
                    index === activeRealWorld && (
                      <motion.div
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        // className={classes.aiSectionRight}
                      >
                        <LazyImage
                          alt={listItem.alt}
                          source={listItem.image}
                          width={"100%"}
                        />
                      </motion.div>
                    )
                )}
              </div>
            </div>
          </div>
        </section>
      </section>

      <section className={classes.combineSection}>
        <div className={classes.bussinessSuccesSection}>
          <div className={classes.bussinessSuccessContainer}>
            <div className={classes.integrationHeaderItem}>
              <div className={classes.integrationContent}>
                <motion.p
                  className="font-wix-semibold font-20 color-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Features
                </motion.p>
                <motion.h2
                  className="font-wix-semibold font-56 color-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Tailored for business success
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18 color-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  The best CRM for sales reps who want to streamline their sales
                  process, stay organised, and win more deals.
                </motion.p>
              </div>
            </div>

            <section className="sales-manager-logo-carousel">
              <div className="logos-container">
                <div className="scroll-container">
                  <div
                    className="logos-row"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack1.map((logo) => (
                        <div
                          className="logo font-18 font-wix-medium"
                          key={logo.title}
                        >
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row"
                    data-direction="right"
                    data-speed="0.4"
                  >
                    <div className="logos-track">
                      {logotrack2.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
      <div className="container">
        <div className="header">
          <motion.h2
            className="font-wix-semibold font-56 font-black1"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Top 5 simple CRM software for IT and tech teams in 2025
          </motion.h2>
        </div>
        <div className={classes.compareSectionContainer}>
          <div className={classes.compareSectionContainerLeftSection}>
            {compareItems.map((item, index) => (
              <div
                className={clsx(
                  classes.compareSectionLeftItem,
                  activeCompare === `#section${index}` && "active"
                )}
                onClick={() => {
                  scrollToSection(`#section${index}`);
                  setActiveCompare(`#section${index}`);
                }}
              >
                <a
                  className={clsx(
                    "font-22 font-wix-medium font-black1",
                    activeCompare === `#section${index}` && "font-wix-semibold"
                  )}
                  href={`#section${index}`}
                >
                  {item}
                </a>
              </div>
            ))}
          </div>
          <div className={classes.compareSectionContainerRightSection}>
            {compareData.map((data, outerIndex) => (
              <div
                className={classes.compareItemContainer}
                id={`#section${outerIndex}`}
              >
                <h3
                  className="font-40 font-wix-semibold font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.title}
                </h3>
                <p
                  className="font-wix-regular font-18 font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.desc}
                </p>
                <img alt={data.alt} className="productImage" src={data.img} />
                <div className={classes.faqsContainer}>
                  {data.features.map((faq, innerIndex) => (
                    <motion.div
                      className={classes.faqBox}
                      onClick={() =>
                        setActiveAccordian(
                          `${outerIndex}-${innerIndex}` === activeAccordian
                            ? -1
                            : `${outerIndex}-${innerIndex}`
                        )
                      }
                      transition={{ duration: 1, delay: innerIndex * 0.01 }}
                      whileInView={{ opacity: [0, 1], y: [50, 0] }}
                    >
                      <div className={classes.topFiveHeader}>
                        <h3 className="font-20 font-wix-semibold">
                          {faq.title}
                        </h3>
                        <img
                          alt="Arrow"
                          className={clsx(
                            classes.downArrow,
                            `${outerIndex}-${innerIndex}` === activeAccordian &&
                              "active"
                          )}
                          src={downArrow}
                        />
                      </div>
                      <Collapse
                        className={classes.body}
                        in={activeAccordian === `${outerIndex}-${innerIndex}`}
                      >
                        <p className="font-18 font-wix-regular color-black2">
                          {faq.desc}
                        </p>
                      </Collapse>
                    </motion.div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={classes.testimonials}>
        <TestimonialSlider
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
          heading={"Real stories. Real results."}
          noButton={true}
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFFFFF"}
          faqs={faqs}
          heading={"Frequently asked questions - CRM for IT and tech teams"}
        />
      </div>
      <DesignCrmCarousel backgroundImage={""} bgColor={"#e9f4fd"} />
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              CRM for IT teams | Scale service operations with Pepper Cloud
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SalesMangers;
